import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { GOALS } from "./shared";

export function GoalInputs({ goals, setGoals, prefix }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      {GOALS.map(([k, l]) => (
        <label key={k} className="text-xs text-slate-600 space-y-1">
          <span className="font-medium">{l} per week</span>
          <Input inputMode="numeric" value={goals[k]} placeholder="Your goal" data-testid={`${prefix}-goal-${k}`}
                 onChange={(e) => setGoals((g) => ({ ...g, [k]: e.target.value.split(/[.,]/)[0].replace(/[^0-9]/g, "") }))} className="h-9" />
        </label>
      ))}
    </div>
  );
}

export const parseGoals = (g) => (GOALS.every(([k]) => /^\d+$/.test(g[k] ?? "")) ? Object.fromEntries(GOALS.map(([k]) => [k, Number(g[k])])) : null);

export default function StpOptIn({ onDone }) {
  const [open, setOpen] = useState(false);
  const [goals, setGoals] = useState({ conversations: "", contact_exchanges: "", dtms: "", mg1s: "" });
  const [voluntary, setVoluntary] = useState(false);
  const [busy, setBusy] = useState(false);
  const g = parseGoals(goals);
  const ready = g && voluntary;
  const submit = async () => {
    setBusy(true);
    try { await api.post("/stp/opt-in", { goals: g, voluntary }); toast.success("You're in STP Run!"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't join"); }
    setBusy(false);
  };
  return (
    <div className="space-y-3">
      {!open ? (
        <Button onClick={() => setOpen(true)} data-testid="stp-join-open" className="rounded-full bg-[#0A1F44] text-white">Join STP Run (optional)</Button>
      ) : (
        <div className="space-y-3 rounded-lg border border-[#C9A961]/40 p-3 bg-[#C9A961]/5" data-testid="stp-join-form">
          <p className="text-xs text-slate-600">Set your weekly goals — whole numbers, 0 or more.</p>
          <GoalInputs goals={goals} setGoals={setGoals} prefix="stp-join" />
          <label className="flex items-start gap-2 text-sm">
            <input type="checkbox" checked={voluntary} onChange={(e) => setVoluntary(e.target.checked)} className="mt-1" data-testid="stp-join-voluntary" />
            I'm choosing to take part. It's optional.
          </label>
          <div className="flex gap-2">
            <Button onClick={submit} disabled={!ready || busy} data-testid="stp-join-submit" className="rounded-full bg-[#0A1F44] text-white">Join</Button>
            <Button variant="ghost" onClick={() => setOpen(false)} className="rounded-full">Cancel</Button>
          </div>
        </div>
      )}
    </div>
  );
}
